import React from "react";
import FinancialBox from "../../components/boxes/FinancialBox";
import Configurer from "../../components/Configurer";
import DataGrid from "../../components/DataGrid";
import { translate } from "../../utils/useful";


class Financial extends React.Component {

    state = {
        data: [
            // { name: '$12', description: 'This is the description',type:'income' },
            // { name: '$120', description: 'This is the description',type:'income' },
            // { name: '$20', description: 'Charged your wallet',type:'charge' },
            // { name: '$100', description: 'This is the description',type:'charge' },

        ],
    }

    render() {
        return (

            <Configurer
                settingsInfo={{ headerTitle: "Account Type", button: { goBack: true } }}
                title={"Account Type"}
                description={"This is the Account Type"}
                className=""
                changeOnUnmount={true}
            // parentConfigure={this.props.parentConfigure??null}
            >
                <div className="px-3" style={{ backgroundColor: '#f2f6f8' }}>
                    <div style={{ padding: '3% 5%', minHeight: '110vh' }}>
                        <div className="px-2 pt-4" >

                            <div className="flexcb w-100">
                                <div className="w-100">
                                    <p className="text-ultra-big font-bold">{translate("Financial")}</p>
                                </div>
                                <button onClick={() => this.props.openMobileMenu()} className="flexcc d-md-none " style={{ flex: 1, boxShadow: '0px 0px 15px #00000005', color: '#789' }}>
                                    <img className=" " src="/images/menu.png" alt="" width="30px" />
                                </button>
                            </div>

                            {/* <p className="text-small" style={{ color: '#9ab' }}>{this.props.user?.info?.fullname}</p> */}
                        </div>

                        <div className="mt-4">
                            <DataGrid isLoading={this.state.isLoadingData} data={this.state.data} component={FinancialBox} col="col-12 col-md-6 " marginBottom={'mb-3'} />
                        </div>
                    </div>
                </div>

            </Configurer>
        )
    }
}


export default Financial
